import React from 'react';
import { twMerge } from 'tailwind-merge';

export function TextArea(
  props: React.TextareaHTMLAttributes<HTMLTextAreaElement>,
) {
  const { className, ...rest } = props;

  return (
    <textarea
      {...rest}
      className={twMerge(
        'self-stretch px-4 py-3.5 bg-neutral-900 rounded-lg outline-1 outline-offset-[-1px] outline-neutral-700 text-white text-sm focus:outline-teal-500',
        className,
      )}
    />
  );
}
